const SINGLE_POST_ACF_BLOCKS = `
    blocks {
        name
            ...on AcfFeaturesBlock {
                blockFeatures {
                    heading
                    description
                    image {
                        srcSet
                    }
                }
            }
            ...on AcfImageWithContentBlock {
                blockImageWithContent {
                    title
                    imagePosition
                    heading
                    fieldGroupName
                    description
                    image {
                        srcSet
                    }
                }
            }
            ...on AcfSliderBlock {
                blockSlider {
                    slides {
                        image {
                            srcSet
                        }
                    }
                }
            }
            ...on AcfAgentBlock {
                blockAcfAgent {
                    agent
                }
            }
        originalContent
            ...on AcfFeaturesListBlock {
                blockFeaturesList {
                    list {
                        description
                        fieldGroupName
                        title
                    }
                }
            }
        originalContent
    }
`;

export default SINGLE_POST_ACF_BLOCKS;